import React, { useEffect, useState , useCallback} from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { SortingRule } from 'react-table';
import { Col, Row } from 'reactstrap';
import TableComponent from '../TableComponent';
import { PartsAndServicesQuotationDTO } from '../../models/Quotation/PartsAndServicesQuotationDTO';
import { Utilities } from '../../helpers/Utilities';
import ButtonComponent from '../ButtonComponent';
import { SupplierQuotationService } from '../../services/SupplierQuotationService';
import InputComponent from '../InputComponent';
import Toast from "../../helpers/Toast";
import SearchSelectComponent, { SelectItemsProps } from "../../components/SearchSelectComponent";
import { SearchPartByName } from '../../models/Parts/SearchPartByName';
import { PartService } from '../../services/PartService';
import ModalComponent from '../ModalComponent';
import { ClientQuotationService } from '../../services/ClientQuotationService';
import { UpdateClientQuotationDTO } from '../../models/Quotation/UpdateClientQuotationDTO';

export type PartsTableComponentType = {
    isEditable: boolean;
    reloadParts: boolean;
    goToPage: number;
    currentPage: number;
    isComplete: boolean;
    onPartsChange: (parts: PartsAndServicesQuotationDTO[]) => void;
    initialParts: PartsAndServicesQuotationDTO[];
    quotationType: string;
    id: number;
    clientId?: number;
    description?: string;
};

const DetailsQuotationPartsTable: React.FC<PartsTableComponentType> = ({
    isEditable,
    reloadParts,
    goToPage,
    currentPage,
    isComplete,
    onPartsChange,
    initialParts,
    quotationType,
    id,
    clientId,
    description
  }) => {
    const intl = useIntl();
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [parts, setParts] = useState<PartsAndServicesQuotationDTO[]>(initialParts || []);
    const [totalPages, setTotalPages] = useState<number>(0);
    const pageSizes: number[] = [5, 15, 30];
    const [pageSize, setPageSize] = useState<number>(5);
    const [initialSortBy] = useState<SortingRule<object>[]>([]);
    const [quantity, setQuantity] = useState<number>(0);
    const [sellingPrice, setSellingPrice] = useState<number>(0);
    let [partId, setPartId] = useState<string>("NaN");
    const [name, setName] = useState<string>("");
    const [costPrice, setCostPrice] = useState<number>(0);
    const partService = new PartService();
    const [selectedPart, setSelectedPart] = useState<SelectItemsProps | null>(null);
    const [inputpart, setInputPart] = useState<string>("");
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmIndex, setConfirmIndex] = useState<number | null>(null);
    const clientQuotationService = new ClientQuotationService();
   
   
    
    const openDeleteConfirm = (index: number) => {
        setConfirmIndex(index);
        setConfirmOpen(true);
    };
    const searchPart = async (name: string): Promise<SelectItemsProps[]> => {
        const searchParams: SearchPartByName = { name };
        const response = await partService.SearchPartByName(searchParams);

        if (!response.success || response.obj === null) {
            Toast.Show("error", response.message);
            return [];
        }

        return response.obj.map((element) => ({
            value: element.erpId,
            label: element.name,
        }));
    };

    const fetchPartDetails = async (erpId: string) => {
        const response = await partService.GetByIdErp(erpId);

        if (response.success && response.obj) {
            const part = response.obj;
            setPartId(part.erpId); 
            setName(part.name);
            setSellingPrice(part.sellingPrice ?? 0); 
            setCostPrice(part.costPrice ?? 0);
        } else {
            Toast.Show("error", response.message);
        }
    };
    

    useEffect(() => {
        onPartsChange(parts);
            setParts(parts);
      }, [onPartsChange]);
    
    const deletePart = (index: number) => {
        
        setParts(prevParts => {
            const updatedParts = prevParts.filter((_, i) => i !== index);
            onPartsChange(updatedParts); 
    
            return updatedParts; 
        });
    };
    useEffect(() => {
        setParts(initialParts);

        onPartsChange(initialParts);
    }, [initialParts]);

    useEffect(() => {
        setParts(parts);
    }, [parts]);

    useEffect(() => {
        RemoveFilters();
    }, [parts]);

    const fetchData = async () => { 
        setParts(parts);
    }
    const AddToTable = async () => {
    if (partId === "NaN" || name === "" || quantity === 0) {
        Toast.Show('error', intl.formatMessage({ id: "Screens.Quotation.Parts.Info.FillAllFields" }));
        return;
    }

    if (parts.some(part => part.partId === String(partId))) {
        Toast.Show('error', intl.formatMessage({ id: "Screens.Quotation.Parts.Info.CodeAlreadyExists" }));
        return;
    }

    if (!id) {
        Toast.Show("error", intl.formatMessage({ id: "Screens.Quotation.Parts.Info.QuotationNotCreated" }));
        return;
    }

    if (!clientId && quotationType === 'ClientQuotation') {
        Toast.Show("error", "Cliente não foi definido");
        return;
    }

    const newPart: PartsAndServicesQuotationDTO = {
        partId: String(partId),
        partName: name,
        quantity: quantity,
        costPrice: costPrice,
        sellingPrice: sellingPrice,
        totalSellingPrice: quantity * sellingPrice,
    };

    const updatedParts = [...parts, newPart];

    const newTotalValue = updatedParts.reduce((sum, part) =>
        sum + part.totalSellingPrice, 0
    );

    const newCostPriceTotal = updatedParts.reduce((sum, part) =>
        sum + (part.quantity * part.costPrice), 0
    );

    const partsAndServicesQuotationDTO: PartsAndServicesQuotationDTO[] = updatedParts.map(part => ({
        partName: part.partName,
        partId: part.partId,
        quantity: part.quantity,
        sellingPrice: part.sellingPrice,
        costPrice: part.costPrice,
        totalSellingPrice: part.totalSellingPrice
    }));

    const updateQuotationDTO: UpdateClientQuotationDTO = {
        quotationId: id,
        clientId: clientId ?? 0,
        description: description || "",
        partsAndServicesQuotationDTO: partsAndServicesQuotationDTO,
        sellingPrice: newTotalValue,
        costPrice: newCostPriceTotal
    };

    setIsLoadingTable(true);

    try {
        const response = await clientQuotationService.Update(updateQuotationDTO, id);

        if (!response?.success) {
            Toast.Show("error", response?.message || "Erro ao gravar a nova peça");
            return;
        }

        setParts(updatedParts);
        onPartsChange(updatedParts);
        Toast.Show("success", "Nova peça adicionada e salva com sucesso!");
        RemoveFilters();
    } catch (error) {
        Toast.Show("error", "Erro ao gravar a nova peça");
    } finally {
        setIsLoadingTable(false);
    }
};

    const savePart = useCallback(async (index: number) => {
    if (!id) {
        Toast.Show("error", "Proposta ainda não foi criada, não é possível atualizar");
        return;
    }

    if (!clientId && quotationType === 'ClientQuotation') {
        Toast.Show("error", "Cliente não foi definido");
        return;
    }

    try {
        setIsLoadingTable(true);

        const quantityInput = document.querySelector<HTMLInputElement>(`.new-quantity-input[data-row-index="${index}"]`);
        const costPriceInput = document.querySelector<HTMLInputElement>(`.cost-price-input[data-row-index="${index}"]`);
        const sellingPriceInput = document.querySelector<HTMLInputElement>(`.selling-price-input[data-row-index="${index}"]`);

        if (!quantityInput || !costPriceInput || (quotationType === 'ClientQuotation' && !sellingPriceInput)) {
            Toast.Show("error", "Erro ao obter os valores dos campos");
            return;
        }

        const newQuantity = parseInt(quantityInput.value);
        const newCostPrice = parseFloat(costPriceInput.value);
        const newSellingPrice = quotationType === 'ClientQuotation' 
            ? parseFloat(sellingPriceInput!.value) 
            : parts[index].sellingPrice;
        const newTotal = newQuantity * newSellingPrice;

        

        setParts(prevParts => {
            const updatedParts = [...prevParts];
            updatedParts[index] = {
                ...updatedParts[index],
                quantity: newQuantity,
                costPrice: newCostPrice,
                sellingPrice: newSellingPrice,
                totalSellingPrice: newTotal,
            };

            const newTotalValue = updatedParts.reduce((sum, part) => 
                sum + part.totalSellingPrice, 0
            );
            
            const newCostPriceTotal = updatedParts.reduce((sum, part) => 
                sum + (part.quantity * part.costPrice), 0
            );

            const partsAndServicesQuotationDTO: PartsAndServicesQuotationDTO[] = updatedParts.map(part => ({
                partName: part.partName,
                partId: part.partId,
                quantity: part.quantity,
                sellingPrice: part.sellingPrice,
                costPrice: part.costPrice,
                totalSellingPrice: part.totalSellingPrice
            }));

            const clientIdNumber = clientId ?? 0; 
            const updateQuotationDTO: UpdateClientQuotationDTO = {
                quotationId: id,
                clientId: clientIdNumber,
                description: description || "",
                partsAndServicesQuotationDTO: partsAndServicesQuotationDTO,
                sellingPrice: newTotalValue,
                costPrice: newCostPriceTotal
            };      

           

            (async () => {
                try {
                    let response;
                    
                     response = await clientQuotationService.Update(updateQuotationDTO, id);

                    if (!response?.success) {
                        Toast.Show("error", response?.message || "Erro ao gravar as alterações da parte");
                    } else {
                        Toast.Show("success", "Alterações da parte salvas com sucesso!");
                        
                        onPartsChange(updatedParts);
                    }
                } catch (error) {
                    Toast.Show("error", "Erro ao gravar as alterações da parte");
                } finally {
                    setIsLoadingTable(false);
                }
            })();

            return updatedParts;
        });
    } catch (error) {
        Toast.Show("error", "Erro ao gravar as alterações da parte");
        setIsLoadingTable(false);
    }
}, [id, clientId, description, clientQuotationService, onPartsChange, parts, quotationType]);

    

    const RemoveFilters = () => {
        setPartId("");
        setName("");
        setQuantity(0);
        setSellingPrice(0);
        setCostPrice(0);
    }
    const columns = React.useMemo(() => {
        if (quotationType === 'SupplierQuotation') {
            return [
                {
                    
                    Header: <FormattedMessage id="Screens.Quotation.Parts.Label.Code" />,
                    accessor: "partId",
                    width: 15,
                    Cell: ({ cell }: { cell: { value: number } }) => {
                        const partId = cell.value;
                        return (
                            <div>
                                {partId === 0 ? (
                                    <FormattedMessage id="Screens.Quotation.Parts.Message.NoPart" />
                                ) : (
                                    partId
                                )}
                            </div>
                        );
                    },
                },
                {
                    Header: <FormattedMessage id="Screens.Quotation.Parts.Label.Name" />,
                    accessor: "partName",
                    width: 35,
                },
                {
                    Header: <FormattedMessage id="Screens.Quotation.Parts.Label.Quantity" />,
                    accessor: "quantity",
                    width: 25,
                },
                {
                    Header: <FormattedMessage id="Screens.Quotation.Parts.Label.CostPrice" />,
                    accessor: "costPrice",
                    width: 25,
                },
                {
                    Header: <FormattedMessage id="Screens.Quotation.Parts.Label.Actions"/>,
                    width: 20,
                    Cell: ({ row: { index } }: { row: { index: number } }) => (
                        <ButtonComponent
                            style={{ margin: 'auto', width: '40%'}}
                            text= {intl.formatMessage({ id: "Screens.Quotation.Parts.Remove"})}
                            onClick={() => deletePart(index)}
                            disabled={isComplete || !isEditable}
                        />
                    ),
                },
            ];
        }
    
        if (quotationType === 'ClientQuotation') {
            return [
                {
                    Header: <FormattedMessage id="Screens.Quotation.Parts.Label.Code" />,
                    accessor: "partId",
                    width: 15,
                    Cell: ({ cell }: { cell: { value: number } }) => {
                        const partId = cell.value;
                        return (
                            <div>
                                {partId === 0 ? (
                                    <FormattedMessage id="Screens.Quotation.Parts.Message.NoPart" />
                                ) : (
                                    partId
                                )}
                            </div>
                        );
                    },
                },
                {
                    Header: <FormattedMessage id="Screens.Quotation.Parts.Label.Name" />,
                    accessor: "partName",
                    width: 25,
                },
                {
                    Header: <FormattedMessage id="Screens.Quotation.Parts.Label.Quantity" />,
                    accessor: "quantity",
                    width: 15,
                    Cell: ({ row, value }: { row: { index: number }; value: number }) => {
                        if (!isEditable || isComplete) {
                        return <span>{value}</span>;
                        }
                        return (
                        <input
                            type="number"
                            min={1}
                            value={value}
                            data-row-index={row.index}
                            className="new-quantity-input"
                            onChange={(e) => {
                                const newQuantity = parseInt(e.target.value);
                                if (!isNaN(newQuantity) && newQuantity > 0) {
                                    setParts(prevParts => {
                                    const updatedParts = [...prevParts];
                                    updatedParts[row.index] = {
                                        ...updatedParts[row.index],
                                        quantity: newQuantity,
                                        totalSellingPrice: newQuantity * updatedParts[row.index].sellingPrice,
                                    };
                                    onPartsChange(updatedParts);
                                    return updatedParts;
                                    });
                                }
                                }}

                            style={{ width: '80px' }}
                        />
                        );
                    },
                },
                {
                   Header: <FormattedMessage id="Screens.Quotation.Parts.Label.CostPrice" />,
                    accessor: "costPrice",
                    width: 15,
                    Cell: ({ row, value }: { row: { index: number }; value: number }) => {
                        if (!isEditable || isComplete) {
                        return <span>{value.toFixed(2)}</span>;
                        }

                        return (
                        <input
                            type="number"
                            min={0}
                            step={0.01}
                            data-row-index={row.index}
                            className="cost-price-input"
                            value={value}
                            onChange={(e) => {
                                const newCostPrice = parseFloat(e.target.value);
                                if (!isNaN(newCostPrice) && newCostPrice >= 0) {
                                    setParts(prevParts => {
                                    const updatedParts = [...prevParts];
                                    updatedParts[row.index] = {
                                        ...updatedParts[row.index],
                                        costPrice: newCostPrice,
                                    };
                                    onPartsChange(updatedParts);
                                    return updatedParts;
                                    });
                                }
                                }}

                            style={{ width: '80px' }}
                        />
                        );
                    },
                },
                {
                    Header: <FormattedMessage id="Screens.Quotation.Parts.Label.SellingPrice" />,
                    accessor: "sellingPrice",
                    width: 15,
                    Cell: ({ row, value }: { row: { index: number }; value: number }) => {
                        if (!isEditable || isComplete) {
                        return <span>{value}</span>;
                        }

                        return (
                        <input
                            type="number"
                            min={0}
                            step="0.01"
                            value={value}
                            data-row-index={row.index}
                            className="selling-price-input"

                            onChange={(e) => {
                            const newSellingPrice = parseFloat(e.target.value);
                            if (!isNaN(newSellingPrice) && newSellingPrice >= 0) {
                                setParts(prevParts => {
                                const updatedParts = [...prevParts];
                                const currentPart = updatedParts[row.index];
                                updatedParts[row.index] = {
                                    ...currentPart,
                                    sellingPrice: newSellingPrice,
                                    totalSellingPrice: currentPart.quantity * newSellingPrice, // atualiza o total no fim da linha
                                };
                                onPartsChange(updatedParts);
                                return updatedParts;
                                });
                            }
                            }}
                            style={{ width: '80px' }}
                        />
                        );
                },
                },
                {
                    Header: <FormattedMessage id="Screens.Quotation.Parts.Label.TotalValue" />,
                    accessor: "totalSellingPrice",
                    width: 15,
                },
                {
                    Header: <FormattedMessage id="Screens.Quotation.Parts.Label.Actions"/>,
                    width: 20,
                    Cell: ({ row: { index } }: { row: { index: number } }) => (
                        <ButtonComponent
                            style={{ margin: 'auto', width: '40%'}}
                            text= {intl.formatMessage({ id: "Screens.Quotation.Parts.Remove"})}
                            onClick={() => openDeleteConfirm(index)}
                            disabled={isComplete || !isEditable}
                        />
                    ),
                },
                {
                    Header: "Gravar",
                    accessor: "save",
                    width: 10,
                    Cell: ({ row: { index } }: { row: { index: number } }) => (
                        <ButtonComponent
                            style={{ margin: 'auto', width: '40%' }}
                            text={intl.formatMessage({ id: "Screens.Country.Button.CreateClient.Create" })}
                            onClick={() => savePart(index)}
                            disabled={isComplete || isLoadingTable}
                            loading={isLoadingTable}
                        />
                    ),
                },
            ];
        }
        return [];
    }, [quotationType, isComplete]);
    return (
        
        <div>
            <ModalComponent
            IsOpen={confirmOpen}
            title={intl.formatMessage({ id: "Screens.Quotation.Parts.ConfirmRemove.Title" })}
            text={intl.formatMessage(
                { id: "Screens.Quotation.Parts.ConfirmRemove.Text" },
                { name: parts[confirmIndex!]?.partName }
            )}
            OnClickLeft={() => {
                if (confirmIndex !== null) {
                deletePart(confirmIndex);
                }
                setConfirmOpen(false);
            }}
            OnClickRight={() => setConfirmOpen(false)}
            buttonLeft={"Sim"}
            buttonRight={"Não"}
            />
            {isEditable && (
                <>
            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
            <Row xl={12} lg={12} md={12} sm={12} xs={12}>
                    <SearchSelectComponent xl={1.5} lg={2} md={4} sm={8} xs={12}
                        label={intl.formatMessage({ id: "Pesquisar peças" })}
                        required={true}
                        loadOptions={searchPart} 
                        onChange={(e: SelectItemsProps) => {
                            setSelectedPart(e);
                            setInputPart(e.value);
                            fetchPartDetails(e.value);
                        }}
                        value={selectedPart}
                        style={{ width: "100%" }}
                        />
                        <InputComponent xl={1.5} lg={2} md={4} sm={8} xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={partId}
                            label={intl.formatMessage({ id: "Screens.Quotation.Parts.Label.Code" })}
                            readOnly={true}
                        />
                        
                        <InputComponent xl={1.5} lg={2} md={4} sm={8} xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={name}
                            label={intl.formatMessage({ id: "Screens.Quotation.Parts.Label.Name" })}
                            readOnly={true}
                        />
                        <InputComponent
                            xl={1.5} lg={2} md={4} sm={8} xs={12}
                            style={{ width: "100%" }}
                            type={"number"}
                            value={quantity}
                            label={intl.formatMessage({ id: "Screens.Quotation.Parts.Label.Quantity" })}
                            required={true}
                            readOnly={isComplete}
                            onChange={(e: number) => setQuantity(e)}
                        />
                        <InputComponent xl={1.5} lg={2} md={4} sm={8} xs={12}
                            style={{ width: "100%" }}
                            type={"number"}
                            value={costPrice}
                            label={intl.formatMessage({ id: "Screens.Quotation.Parts.Label.CostPrice" })}
                            readOnly={isComplete}
                            onChange={(e: number) => setCostPrice(e)}
                        />
                        {quotationType === 'ClientQuotation' && (
                            <InputComponent xl={1.5} lg={2} md={4} sm={8} xs={12}
                                style={{ width: "100%" }}
                                type={"number"}
                                value={sellingPrice}
                                label={intl.formatMessage({ id: "Screens.Quotation.Parts.Label.SellingPrice" })}
                                readOnly={isComplete}
                                onChange={(e: number) => setSellingPrice(e)}
                            />
                        )}
                    </Row>
                </Col>
                <Row>
                    <Col xl={1} lg={2} md={3} sm={4} xs={6}>
                        <ButtonComponent
                            style={{ marginTop: '10%', width: '100%'}}
                            text={intl.formatMessage({ id: "Screens.Assistances.Parts.Label.ClearBoxes" })}
                            onClick={() => RemoveFilters()}
                            disabled={isComplete}
                        />
                    </Col>
                    <Col xl={1} lg={2} md={3} sm={4} xs={6}>
                        <ButtonComponent
                            style={{ marginTop: '10%',width: '100%'}}
                            text={intl.formatMessage({ id: "Screens.Quotation.Parts.Label.Add" })}
                            onClick={() => AddToTable()}
                            disabled={isComplete}
                        />
                    </Col>
                </Row>
                </>
            )}
            <Row xl={12} lg={12} md={12} sm={12} xs={12}>
                <Row style={{ margin: "1rem 0px" }}>
                    <TableComponent
                        goToPage={goToPage}
                        loading={isLoadingTable}
                        pageCount={totalPages}
                        columns={columns.map(column => ({
                            ...column,
                            accessor: String(column.accessor) 
                        }))}
                        manualPagination={true}
                        fetchData={() => {}}
                        pageSizes={pageSizes}
                        initialPage={currentPage}
                        initialPageSize={pageSize}
                        initialSortBy={initialSortBy}
                        data={parts}
                        dontOrderLastCollumn={true}
                        dontOrderFirstCollumn={false}
                    />
                </Row>
            </Row>
        </div>
    )
}
export default DetailsQuotationPartsTable
